<template>
  <!-- 授权 -->
  <div class="ff_auth">
    <div class="td-header">
      <div class="tdh-left">
        <span class="tdhl-rect-icon" />
        <router-link
          tag="span"
          to="/workbench"
          class="tdhl-title"
        >应用中心</router-link>
        <span class="su-icon-arrow tdhl-arrow-icon" />
        <span class="tdhl-subtitle">{{ titleMap[$route.query.type] }}-{{ $route.query.name }}</span>
      </div>
      <router-link
        tag="span"
        to="/workbench"
        class="tdh-right"
      >返回到工作台</router-link>
    </div>
    <div
      class="auth-main"
      style="margin:20px;"
    >
      <div class="am-header">
        <div class="amh-left">
          <sw-button
            icon="su-icon-plus"
            type="primary"
            @click="openAuthDialog"
          >添加授权</sw-button>
        </div>
        <!-- <div class="amh-right">
          <sw-search
            :placeholder="'请输入关键字进行搜索'"
            style="height: 32px; width: 260px"
            @search="searchHandle"
          />
          <div class="amhr-renew" @click="reNewComponent">
            <i class="su-icon-renew" />
          </div>
        </div>-->
      </div>
      <div
        v-loading="tableLoading"
        class="am-main"
      >
        <sw-table
          :show-selection="false"
          :table-name="'ff-auth'"
          :table-data="tableData"
          :table-title="tableTitle"
          :page-sizes="[10,15,20,25]"
          :total-count="tableCount"
          :page-size="pageSize"
          :has-add-button="false"
          :table-operation="tableOperation1"
          @operation-handle="operationHandle"
          @size-change="changeSize"
          @change-page="changePage"
          @next-page="changePage"
          @prev-page="changePage"
        />
      </div>
    </div>
    <sw-slide-dialog
      :visible.sync="dialogFlag"
      :title="'添加'+ titleMap[$route.query.type] "
      width="30%"
    >
      <span slot="footer">
        <sw-button
          size="small"
          @click="dialogFlag=!dialogFlag"
        >取 消</sw-button>
        <sw-button
          size="small"
          type="primary"
          @click="submitDialogForm('authDiaLogForm')"
        >确 定</sw-button>
      </span>
      <el-form
        ref="authDiaLogForm"
        :model="authDiaLogForm"
        :rules="adfRules"
        :sw-validator="true"
        class="auth-dialog-form"
        label-width="100px"
      >
        <el-form-item
          prop="transferRadio"
          label="授权类型"
          style
        >
          <el-radio-group v-model="transferRadio">
            <el-radio :label="1">授权给用户</el-radio>
            <el-radio :label="2">授权给用户组</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="currentSelect"
          label="授权给"
          style
        >
          <div
            v-loading="selectInputLoading"
            style=" margin-top:10px; display: flex; position: relative"
          >
            <el-select
              v-el-select-loadmore="selectLoadmore"
              ref="select"
              v-model="authDiaLogForm.currentSelect"
              :placeholder="transferRadio === 1?'请选择用户': '请选择用户组'"
              :filter-method="asyncData"
              style=" font-size: 12px"
              filterable
              @change="handleSelectChange"
              @visible-change="handleDropChange"
            >
              <div v-loading="selectLoading&&selectDataType==='search'">
                <el-option
                  v-for="item in selectOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <div :style="{display: 'flex',justifyContent: 'space-between'}">
                    <span
                      v-if="transferRadio===1"
                      style="flex: 1"
                    >{{ item.username }}</span><span style="flex: 1; padding: 0 10px">{{ item.name }}</span><span
                      v-if="transferRadio===1"
                      style="flex: 1"
                    >{{ item.organizationName }}</span>
                  </div>
                </el-option>
                <div
                  v-loading="selectLoading&&selectDataType==='scroll'&&hasMore"
                  style="margin-top:20px"
                />
                <div
                  v-if="!hasMore"
                  style="text-align: center; font-size: 10px;color:#ccc; margin-top: 5px"
                >无更多数据</div>
              </div>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item
          prop="des"
          label="授权说明"
          class="authDialogDes"
          style="margin-top:20px"
        >
          <sw-input
            v-model="authDiaLogForm.des"
            maxlength="250"
            show-word-limit
            type="textarea"
          />
        </el-form-item>
      </el-form>
    </sw-slide-dialog>
  </div>
</template>
<script>
import { debounce, parseTime } from '@/utils/index.js'
import service from '@/utils/service'
import '../css/auth.scss'
export default {
  directives: {
    'el-select-loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          '.el-select-dropdown .el-select-dropdown__wrap'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight + 20
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  data () {
    return {
      optionSpanWidth: 'none',
      hasMore: true,
      selectWidth: '100%',
      selectInputLoading: false,
      selectSearchValue: '',
      selectDataType: 'scroll',
      selectLoading: false,
      selectOptions: [],
      selectConfig: {
        pageIndex: 1,
        pageSize: 10
      },
      ADFTLoading: false,
      tableLoading: false,
      titleMap: {
        app: '应用授权',
        appgroup: '应用组授权',
        business: '业务组授权'
      },
      input: '',
      value: '',
      currentPage: 1,
      pageSize: 10,
      dialogFlag: false,
      tableCount: 0,

      tableData: [],
      tableTitle: [
        { prop: 'auth_type', label: '授权类型', width: '120', sortable: false },
        { prop: 'auth_result', label: '授权结果', width: '240', sortable: true },
        { prop: 'auth_des', label: '授权说明', width: '120', sortable: true },
        { prop: 'auth_time', label: '授权时间', width: '120', sortable: true }
      ],
      tableOperation1: [
        { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
      ],
      selectRadio: 1,
      transferSelected: [],
      selectlist: [],
      transferRadio: 1,
      authDiaLogForm: {
        multiSelection: [],
        des: '',
        transferRadio: 1,
        currentSelect: '',
        currentSelectObj: ''
      },
      adfRules: {
        transferRadio: [
          { required: true, message: '请选择用户或者用户组', trigger: 'change' }
        ],
        des: [{ required: true, message: '请输入授权说明', trigger: 'blur' }],
        currentSelect: [
          { required: true, message: '请选择授权用户或者用户组', trigger: 'change' }
        ]
      },
      userList: [],
      userGroupList: [],
      username: '',
      userPage: 1,
      rolename: '',
      userGroupPage: 1,
      appList: [],
      appGroupList: [],
      processRoleList: [],
      total: 0
    }
  },
  watch: {
    // 如果 `transferRadio` 发生改变，这个函数就会运行
    transferRadio: function (newValue, oldValue) {
      this.hasMore = true
      this.selectInputLoading = true
      this.authDiaLogForm.transferRadio = newValue
      this.selectLoading = false
      this.selectLoadmore = false
      this.selectOptions = []
      this.selectConfig.pageIndex = 1
      this.authDiaLogForm.currentSelect = ''
      this.selectSearchValue = ''
      this.getSelectData()
      this.total = 0
    },
    optionSpanWidth (newVal, oldVal) {
      // console.log(newVal, oldVal)
    }
  },
  created () {
    this.$watch(
      'selectSearchValue',
      debounce((newValue, oldValue) => {
        this.searchSelectData(newValue)
      }, 1000)
    )
  },
  mounted () {
    this.getData()
  },
  methods: {
    selectLoadmore () {
      this.getSelectData()
    },
    asyncData (val) {
      this.selectSearchValue = val
    },
    operationHandle (id, operation) {
      if (operation === 'delete') {
        this.confirmDelete(id)
      }
    },
    confirmDelete (id) {
      this.$swConfirm('<p style="display: flex; justify-content: center; align-items: center; font-size: 16px; color: #000;"><i class="su-icon-question" style="font-size: 22px; color: #F5A623;margin-right: 8px"></i>确认要删除该授权吗？</p><br><p style="font-size: 14px; color: rgba(2, 21, 37,0.45); text-align: center;"></p>', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        service.get('/v1/authorization/delAuth?id=' + id)
          .then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getData()
          }).catch(error => {
            this.$swMessage.error(error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    getData () {
      switch (this.$route.query.type) {
        case 'app':
          this.getAppAuthList()
          break
        case 'appgroup':
          this.getAppGroupAuthList()
          break
        case 'business':
          this.getAuthProcessRoleList()
          break
        default:
          console.error('路由参数错误')
      }
    },
    openAuthDialog () {
      if (!this.selectOptions.length) {
        this.selectInputLoading = true
        this.getSelectData()
      }
      this.authDiaLogForm.multiSelection = []
      this.authDiaLogForm.des = ''
      this.authDiaLogForm.transferRadio = 1
      this.authDiaLogForm.currentSelect = ''
      this.authDiaLogForm.currentSelectObj = ''
      this.dialogFlag = true
    },
    getUserListTotal () {
      service.get('/v1/data/share/user/pageTotalCount', {
        params: {
          keyword: this.selectSearchValue
        }
      }).then(res => {
        // 没有使用到total，判断结束的标准是接口返回的list为空，
        // 会导致最后也会不停发请求，只不过拿到的数据都是空
        this.total = res.data.totalCount
        this.getUserList()
      })
    },
    getUserList () {
      if (this.selectLoading) return
      this.selectLoading = true
      service
        .get('v1/data/share/user/pageTotalUnused', {
          params: {
            keyword: this.selectSearchValue,
            pageNum: this.selectConfig.pageIndex,
            pageSize: this.selectConfig.pageSize
          }
        })
        .then(res => {
          if (!res.data.length) {
            this.hasMore = false
          }
          const tempRes = res.data.map(item => {
            return { id: item.id, username: item.accountName, name: item.name, organizationName: item.organizationName }
          })
          if (this.selectDataType === 'search') {
            this.selectOptions = tempRes
          } else {
            this.selectOptions = [...this.selectOptions, ...tempRes]
          }
          this.selectConfig.pageIndex++
        })
        .catch(error => {
          this.$swMessage.error(error)
        }).finally(() => {
          this.selectInputLoading = false
          this.selectLoading = false
        })
    },
    getRoleList (val) {
      if (this.selectLoading) return
      this.selectLoading = true
      service
        .get('v1/role/showRoleList', {
          params: {
            roleName: this.selectSearchValue,
            page: this.selectConfig.pageIndex,
            limit: this.selectConfig.pageSize
          }
        })
        .then(res => {
          if (!res.data.length) {
            this.hasMore = false
          }
          const tempRes = res.data.map(item => {
            return {
              id: item.id,
              name: item.roleName,
              describe: item.remark
            }
          })
          if (this.selectDataType === 'search') {
            this.selectOptions = tempRes
          } else {
            this.selectOptions = [...this.selectOptions, ...tempRes]
          }
          this.selectConfig.pageIndex++
        })
        .catch(error => {
          this.$swMessage.error(error)
        }).finally(() => {
          this.selectInputLoading = false
          this.selectLoading = false
        })
    },
    getAppAuthList () {
      this.tableLoading = true
      service
        .get('/v1/authorization/getAppAuthList', {
          params: {
            appId: this.$route.params.id,
            page: this.currentPage,
            limit: this.pageSize
          }
        })
        .then(res => {
          this.tableLoading = false
          this.tableCount = res.count
          this.tableData = res.data.map((item, index) => {
            return this.parseItem(item, index)
          })
        })
        .catch(error => {
          this.$swMessage.error(error)
        })
    },
    getAppGroupAuthList () {
      this.tableLoading = true
      service
        .get('/v1/authorization/getAppGroupAuthList', {
          params: {
            ffGroupID: this.$route.params.id,
            page: 1,
            limit: 10
          }
        })
        .then(res => {
          this.tableLoading = false
          this.tableCount = res.count
          this.tableData = res.data.map((item, index) => {
            return this.parseItem(item, index)
          })
        })
        .catch(error => {
          this.$swMessage.error(error)
        })
    },
    getAuthProcessRoleList () {
      this.tableLoading = true
      service
        .get('/v1/authorization/getAuthProcessRoleList', {
          params: {
            id: this.$route.params.id,
            page: this.currentPage,
            limit: this.pageSize
          }
        })
        .then(res => {
          this.tableLoading = false
          this.tableCount = res.count
          this.tableData = res.data.map((item, index) => {
            return this.parseItem(item, index)
          })
        })
        .catch(error => {
          this.$swMessage.error(error)
        })
    },
    parseItem (item, index) {
      let _item
      switch (item.authType) {
        case 'user':
          _item = {
            id: item.id,
            auth_type: '用户',
            auth_des: item.description,
            auth_result: item.userName + '-' + item.realName + '-' + item.organizationName,
            auth_time: parseTime(item.createTime)
          }
          break
        case 'userGroup':
          _item = {
            id: item.id,
            auth_type: '用户组',
            auth_des: item.description,
            auth_result: item.groupName,
            auth_time: parseTime(item.createTime)
          }
          break
        default:
          _item = {
            id: item.id,
            auth_type: '用户组',
            auth_des: item.description,
            auth_result: item.groupName,
            auth_time: parseTime(item.createTime)
          }
      }
      return _item
    },
    reNewComponent () {
      this.getData()
    },
    changeSize (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getData()
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    },
    editAuth (id) {
      this.dialogFlag = true
    },
    addAppAuth () {
      var authorizedId, userGroupId
      if (this.transferRadio === 1) {
        authorizedId = this.authDiaLogForm.currentSelect
        userGroupId = ''
      } else {
        authorizedId = ''
        userGroupId = this.authDiaLogForm.currentSelect
      }
      service
        .post('/v1/authorization/doAuth', {
          appId: this.$route.params.id,
          authorizedId: authorizedId,
          userGroupId: userGroupId,
          description: this.authDiaLogForm.des,
          type: 'app'
        })
        .then(res => {
          this.$swMessage({
            message: res.msg,
            type: 'success'
          })
          this.getData()
          this.dialogFlag = false
        })
        .catch(error => {
          this.$swMessage.error(error)
        })
    },
    addAppGroupAuth () {
      var authorizedId, userGroupId
      if (this.transferRadio === 1) {
        authorizedId = this.authDiaLogForm.currentSelect
        userGroupId = ''
      } else {
        authorizedId = ''
        userGroupId = this.authDiaLogForm.currentSelect
      }
      service
        .post('/v1/authorization/doAuth', {
          appGroupId: this.$route.params.id,
          authorizedId: authorizedId,
          userGroupId: userGroupId,
          description: this.authDiaLogForm.des,
          type: 'group'
        })
        .then(res => {
          this.$swMessage({
            message: res.msg,
            type: 'success'
          })
          this.getData()
          this.dialogFlag = false
        })
        .catch(error => {
          this.$swMessage.error(error)
        })
    },
    addProcessRoleAuth () {
      var authorizedId, userGroupId
      if (this.transferRadio === 1) {
        authorizedId = this.authDiaLogForm.currentSelect
        userGroupId = ''
      } else {
        authorizedId = ''
        userGroupId = this.authDiaLogForm.currentSelect
      }
      service
        .post('/v1/authorization/authProcessRole', {
          processRoleId: this.$route.params.id,
          processRoleName: this.$route.query.name,
          authorizedId: authorizedId,
          userGroupId: userGroupId,
          description: this.authDiaLogForm.des,
          type: 'admin'
        })
        .then(res => {
          this.$swMessage({
            message: res.msg,
            type: 'success'
          })
          this.getData()
          this.dialogFlag = false
        })
        .catch(error => {
          this.$swMessage.error(error)
        })
    },
    submitDialogForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          switch (this.$route.query.type) {
            case 'app':
              this.addAppAuth()
              break
            case 'appgroup':
              this.addAppGroupAuth()
              break
            case 'business':
              this.addProcessRoleAuth()
              break
            default:
              console.error('参数错误')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSelectData () {
      this.selectDataType = 'scroll'
      if (this.transferRadio === 1) {
        if (this.selectConfig.pageIndex === 1) {
          this.getUserListTotal()
        } else {
          this.getUserList()
        }
      } else {
        this.getRoleList()
      }
    },
    searchSelectData (val) {
      this.selectDataType = 'search'
      this.selectConfig.pageIndex = 1
      this.hasMore = true
      if (this.transferRadio === 1) {
        this.getUserListTotal(val)
      } else {
        this.getRoleList(val)
      }
    },
    handleSelectChange (val) {
      this.authDiaLogForm.currentSelectObj = this.selectOptions.filter(item => {
        return val === item.id
      })
    },
    handleDropChange (visibile) {
      this.optionSpanWidth = this.$refs.select.$el.getBoundingClientRect().width / 2
    }
  }
}
</script>
<style lang="scss" scoped>
.ff_auth {
  .td-header {
    box-sizing: border-box;
    height: auto !important;
    padding: 5px 20px;
    padding-bottom: 0;
    display: flex;
    justify-content: space-between;
    .tdh-left {
      display: flex;
      justify-content: center;
      align-items: center;
      .tdhl-rect-icon {
        margin-right: 4px;
        width: 3px;
        height: 12px;
        background: linear-gradient(
          177deg,
          rgba(97, 193, 190, 1) 0%,
          rgba(51, 148, 225, 1) 100%
        );
      }
      .tdhl-title {
        cursor: pointer;
        margin-right: 4px;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(98, 111, 121, 1);
        line-height: 20px;
      }
      .tdhl-arrow-icon {
        margin-right: 4px;
        transform: rotate(-90deg);
        font-size: 12px;
        color: #bec9d2;
      }
      .tdhl-subtitle {
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(39, 56, 70, 1);
        line-height: 20px;
      }
    }
    .tdh-right {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #314250;
      border-bottom: 1px solid transparent;
      &:hover {
        border-bottom: 1px solid #314250;
      }
    }
  }
}
</style>
